<template>
  <div
    class="fixed z-20 bottom-3 left-1/2 transform -translate-x-1/2 whitespace-nowrap"
    ref="el"
  >
    <slot />
  </div>
</template>

<script setup>
import { onMounted, onUnmounted, ref } from 'vue'

const el = ref()
/**
 * @type {HTMLElement}
 */
const footer = document.querySelector('.Footer')

function checkOffset() {
  function getRectTop(el) {
    var rect = el.getBoundingClientRect()
    return rect.top
  }

  if (
    getRectTop(el.value) + document.body.scrollTop + el.value.offsetHeight >=
    getRectTop(footer) + document.body.scrollTop
  ) {
    el.value.style.position = 'absolute'
  }

  if (
    document.body.scrollTop + window.innerHeight <
    getRectTop(footer) + document.body.scrollTop
  ) {
    el.value.style.position = 'fixed'
  }
}

onMounted(() => {
  window.addEventListener('scroll', checkOffset)
})

onUnmounted(() => {
  window.removeEventListener('scroll', checkOffset)
})
</script>
